module.exports = __webpack_public_path__ + "img/09-the-social-city-enabling.4e890d8a.png";